import React from "react";

export default function ValidationsMessage({ field, isSubmit, message }) {
  return (
    <>
      {(field == "" || field == null) && isSubmit && (
        <span className="text-danger">{message}</span>
      )}
    </>
  );
}
